import { Routes, Route, Navigate } from 'react-router-dom';
import TripDetailComponent from './TripDetailComponent';
import ProfileComponent from './ProfileComponent';
import QuickSightDashboardComponent from './QuickSightDashboardComponent';
import ViolationsComponent from './ViolationsComponent';
import UserDetailComponent from './UserDetailComponent';
import TripQueryComponent from './TripQueryComponent';

const AppRouter = (): JSX.Element => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/trips" replace />} />
      <Route path="/trips" element={<TripQueryComponent />} />
      <Route path="/trips/:tripId" element={<TripDetailComponent />} />
      <Route path="/userProfiles" element={<ProfileComponent />} />
      <Route path="/userProfiles/:user_uuid" element={<UserDetailComponent />} />
      <Route path="/analytics" element={<QuickSightDashboardComponent />} />
      <Route path="/violations" element={<ViolationsComponent />} />
    </Routes>
  );
}

export default AppRouter;